import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {AppStateService} from '../providers/app-state.service';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {tap} from 'rxjs/operators';
import {ReferralsDgSearchResults} from '../models/datagrid-search-results/referrals.dg-search-results';
import {ReferralsService} from "../providers/referrals.service";

@Injectable()
export class ReferralsResolve implements Resolve<ReferralsDgSearchResults> {
  constructor(private referralsService: ReferralsService, private appStateService: AppStateService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<ReferralsDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.referralsService.getResults( environment.DEFAULT_RESULTS_LIMIT,0,'DESC','created').pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
